<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref, watch } from 'vue'
import _ from 'lodash'
import ListingDetail from '@/modules/realestate/views/ListingDetail.vue'
import { useConfirm, useToast } from 'primevue'
import { AttendanceActionTypes, useAttendanceReportStore } from '@/modules/backoffice/stores/attendance.store.ts'
import AttendanceMatrix from '@/modules/backoffice/components/attendance/AttendanceMatrix.vue'


const router = useRouter()
const attendanceReportStore = useAttendanceReportStore()

const confirm = useConfirm()
const toast = useToast()
const pageTabs = computed(() => {
  return attendanceReportStore.tabs
})
const displayTabContent = computed(() => {
  return attendanceReportStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return attendanceReportStore.tableConfig
})
const filter = computed(() => {
  return attendanceReportStore.filter
})
const loading = computed(() => {
  return attendanceReportStore.action_type == AttendanceActionTypes.FETCHING
})
const page = computed(() => {
  return attendanceReportStore.page
})
const pageSize = computed(() => {
  return attendanceReportStore.pageSize
})
const dataSource = computed(() => {
  return attendanceReportStore.data
})
const selectedIds = computed(() => {
  return attendanceReportStore.selectedIds
})

const handleChangeTab = (tab: any) => {

  attendanceReportStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  attendanceReportStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  attendanceReportStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  attendanceReportStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  attendanceReportStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  attendanceReportStore.setFilter(filter)
}

const handleGotoDetail = (e: MouseEvent, item: any) => {

  router.push({ name: 'flash-offer-detail', params: { id: item.id } })
  // attendanceReportStore.newTab({id: item.code, label: `#${item.code} - ${item.subject?.title}`, active: true})
}

const handleRowClick = (e: MouseEvent, item: any) => {

}

const handleChangeSelectedRow = (ids: Array<string|number>) => {
  attendanceReportStore.setSelectedRow(ids)
}

const handleSort = (field: string, direction: string) => {

  attendanceReportStore.toggleSort(field, direction)
}

onMounted(() => {
  // Logic fetching đã chuyển vào AttendanceMatrix.vue
})
</script>

<template>
  <dashboard-layout currentRoute="backoffice/attendance" page-title="Quản lý chấm công" class="attendance-page">
    <template v-if="displayTabContent == 'list'">
      <!-- <filter-list
        :filter="filter"
        @update:filter="handleUpdateFilter"
        @reset:filter="attendanceReportStore.resetFilter"
      /> -->
      <div class="attendance_report">
        <AttendanceMatrix/>
      </div>
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <div :id="tab.id" :key="tab.id">
            dsdsds
          </div>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
